function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
import { extractFormData, parseHTMLSection } from "./CartUtils";
import CartAPI from "./CartAPI";
var SideCart = /*#__PURE__*/function (_HTMLElement) {
  function SideCart() {
    var _this;
    _classCallCheck(this, SideCart);
    _this = _callSuper(this, SideCart);
    _this.cartAPI = CartAPI;
    _this.init();
    return _this;
  }
  _inherits(SideCart, _HTMLElement);
  return _createClass(SideCart, [{
    key: "init",
    value: function init() {
      this.setupEventListeners();
      console.info('SideCart initialized');
    }
  }, {
    key: "open",
    value: function open(triggeredBy) {
      var _this2 = this;
      setTimeout(function () {
        _this2.classList.add('open');
      });
      console.info('SideCart opened triggered by:', triggeredBy);
    }
  }, {
    key: "close",
    value: function close(triggeredBy) {
      var _this3 = this;
      setTimeout(function () {
        _this3.classList.remove('open');
      });
      console.info('SideCart closed triggered by:', triggeredBy);
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      this.initializeOpenEvent();
      this.initializeCloseEvent();
      this.initializeAddEvent();
      this.initializeRemoveEvent();
      this.initializeUpdateEvent();
      this.initializeUpdateVariantEvent();
    }
  }, {
    key: "initializeOpenEvent",
    value: function initializeOpenEvent() {
      var _this4 = this;
      var cartButton = document.querySelector('#side-cart-button');
      if (!cartButton) {
        console.error('The button/anchor with id #side-cart-button could not be found.');
      } else {
        cartButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (typeof _this4.open === 'function') {
            _this4.open('button');
          } else {
            console.error('The open method does not exist on the <side-cart> element.');
          }
        });
      }
    }
  }, {
    key: "initializeCloseEvent",
    value: function initializeCloseEvent() {
      var _this5 = this;
      this.addEventListener('keyup', function (evt) {
        return evt.code === 'Escape' && _this5.close("escape");
      });
      var closeButton = this.querySelector('#side-cart-close');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          return _this5.close("inner-close-button");
        });
      }
      var outsideElement = document.querySelector('side-cart');
      if (outsideElement) {
        document.addEventListener('click', function (event) {
          var isClickInside = outsideElement.contains(event.target);
          if (!isClickInside) {
            outsideElement.classList.remove('open');
          }
        });
      } else {
        console.error('The <side-cart> element was not found.');
      }
    }
  }, {
    key: "initializeAddEvent",
    value: function initializeAddEvent() {
      var _this6 = this;
      var buttons = document.querySelectorAll('.btn-add-to-bag');
      buttons.forEach(function (button) {
        button.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(evt) {
            var _button$closest, _document$querySelect;
            var formData, result, sections;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  evt.preventDefault();
                  (_button$closest = button.closest('.quick-view')) === null || _button$closest === void 0 || _button$closest.classList.toggle('opened');
                  (_document$querySelect = document.querySelector('#quick-view-overlay-js')) === null || _document$querySelect === void 0 || _document$querySelect.classList.toggle('opened');
                  console.info('Add to bag clicked');
                  formData = extractFormData(button);
                  if (!formData) {
                    _context.next = 18;
                    break;
                  }
                  _context.prev = 6;
                  _context.next = 9;
                  return _this6.cartAPI.addToCart(formData);
                case 9:
                  result = _context.sent;
                  console.info('Item added to cart:', result);
                  sections = result['sections'];
                  _this6.renderHTML(sections);
                  _context.next = 18;
                  break;
                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](6);
                  console.error('Failed to add item to cart:', _context.t0);
                case 18:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[6, 15]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeRemoveEvent",
    value: function initializeRemoveEvent() {
      var _this7 = this;
      var buttons = document.querySelectorAll('.cart__item__remove__link');
      buttons.forEach(function (button) {
        button.addEventListener('click', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(evt) {
            var item, formData, result, sections;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  evt.preventDefault();
                  console.info('Remove from cart clicked');
                  item = button.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: 0,
                    sections: 'ajax-side-cart,header'
                  };
                  if (!formData) {
                    _context2.next = 17;
                    break;
                  }
                  _context2.prev = 5;
                  _context2.next = 8;
                  return _this7.cartAPI.removeFromCart(formData);
                case 8:
                  result = _context2.sent;
                  console.info('Item removed from cart:', result);
                  sections = result['sections'];
                  _this7.renderHTML(sections);
                  _context2.next = 17;
                  break;
                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](5);
                  console.error('Failed to remove item from cart:', _context2.t0);
                case 17:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[5, 14]]);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeUpdateEvent",
    value: function initializeUpdateEvent() {
      var _this8 = this;
      var inputs = document.querySelectorAll('.cart__item__quantity__input');
      inputs.forEach(function (input) {
        var inputElement = input;
        inputElement.addEventListener('change', /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(evt) {
            var item, formData, result, sections;
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  evt.preventDefault();
                  console.info('Update cart item');
                  item = inputElement.getAttribute('data-line-item');
                  formData = {
                    id: item,
                    quantity: inputElement.value,
                    sections: 'ajax-side-cart,header'
                  };
                  if (!formData) {
                    _context3.next = 17;
                    break;
                  }
                  _context3.prev = 5;
                  _context3.next = 8;
                  return _this8.cartAPI.updateItemCart(formData);
                case 8:
                  result = _context3.sent;
                  console.info('Cart item updated:', result);
                  sections = result['sections'];
                  _this8.renderHTML(sections);
                  _context3.next = 17;
                  break;
                case 14:
                  _context3.prev = 14;
                  _context3.t0 = _context3["catch"](5);
                  console.error('Failed to update cart item:', _context3.t0);
                case 17:
                case "end":
                  return _context3.stop();
              }
            }, _callee3, null, [[5, 14]]);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeUpdateVariantEvent",
    value: function initializeUpdateVariantEvent() {
      var _this9 = this;
      var inputs = document.querySelectorAll('.cart__item__variant__input');
      inputs.forEach(function (input) {
        var inputElement = input;
        inputElement.addEventListener('change', /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(evt) {
            var item, styleNumber, formDataToDelete, formDataNewItem, resultDelete, resultNew, sections;
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  evt.preventDefault();
                  console.info('Update cart item');
                  item = inputElement.getAttribute('data-line-item');
                  styleNumber = inputElement.getAttribute('data-style');
                  formDataToDelete = {
                    id: item,
                    quantity: 0,
                    sections: 'ajax-side-cart,header'
                  };
                  formDataNewItem = {
                    items: [{
                      id: Number(inputElement.value),
                      quantity: 1,
                      properties: {
                        "Style": styleNumber
                      }
                    }],
                    sections: 'ajax-side-cart,header'
                  };
                  if (!(formDataToDelete && formDataNewItem)) {
                    _context4.next = 23;
                    break;
                  }
                  _context4.prev = 7;
                  _context4.next = 10;
                  return _this9.cartAPI.removeFromCart(formDataToDelete);
                case 10:
                  resultDelete = _context4.sent;
                  console.info('Item removed from cart:', resultDelete);
                  _context4.next = 14;
                  return _this9.cartAPI.addToCart(formDataNewItem);
                case 14:
                  resultNew = _context4.sent;
                  console.info('Item added to cart:', resultNew);
                  sections = resultNew['sections'];
                  _this9.renderHTML(sections);
                  _context4.next = 23;
                  break;
                case 20:
                  _context4.prev = 20;
                  _context4.t0 = _context4["catch"](7);
                  console.error('Failed to remove item from cart:', _context4.t0);
                case 23:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, null, [[7, 20]]);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "initializeConflictedscripts",
    value: function initializeConflictedscripts() {
      var menuToggle = document.querySelector("#menu-mobile-toggle-js");
      var menuMobile = document.querySelector("#menu-mobile-js");
      if (!menuToggle) {
        return;
      }
      menuToggle.addEventListener("click", function () {
        menuToggle.classList.toggle("opened");
        menuMobile === null || menuMobile === void 0 || menuMobile.classList.toggle("opened");
      });
      var menuItem = document.querySelectorAll(".header-menu__item");
      menuItem.forEach(function (item) {
        item.addEventListener("mouseover", function () {
          var _item$querySelector;
          item.classList.add("active");
          (_item$querySelector = item.querySelector(".header-submenu-drawer")) === null || _item$querySelector === void 0 || _item$querySelector.classList.add("active");
        });
        item.addEventListener("mouseout", function () {
          var _item$querySelector2;
          item.classList.remove("active");
          (_item$querySelector2 = item.querySelector(".header-submenu-drawer")) === null || _item$querySelector2 === void 0 || _item$querySelector2.classList.remove("active");
        });
      });
      var header = document.querySelector(".header");
      if (!header) {
        return;
      }
      var topbar = document.querySelector(".header-top-bar");
      if (!topbar) {
        console.error('No se encontró el elemento "header-top-bar".');
        return;
      }
      var topbarHeight = topbar.getBoundingClientRect().height;
      window.onscroll = function () {
        if (window.scrollY > topbarHeight) {
          document.body.classList.add("padding-for-header");
          header.classList.add("sticky");
        } else {
          document.body.classList.remove("padding-for-header");
          header.classList.remove("sticky");
        }
      };
    }
  }, {
    key: "renderHTML",
    value: function renderHTML(sections) {
      var HTMLSection = parseHTMLSection(sections['ajax-side-cart']);
      var sideCart = document.querySelector('side-cart');
      if (!sideCart) {
        console.error('No se encontró el elemento "side-cart".');
        return;
      }
      sideCart.innerHTML = '';
      sideCart === null || sideCart === void 0 || sideCart.appendChild(HTMLSection);
      this.initializeUpdateEvent();
      this.initializeUpdateVariantEvent();
      this.initializeRemoveEvent();
      this.initializeCloseEvent();
      this.open("update");
      var header = parseHTMLSection(sections['header']);
      var headerContainer = document.querySelector('#shopify-section-header');
      if (!headerContainer) {
        console.error('No se encontró el elemento "header container".');
        return;
      }
      headerContainer.innerHTML = '';
      headerContainer === null || headerContainer === void 0 || headerContainer.appendChild(header);
      this.initializeOpenEvent();
      this.initializeConflictedscripts();
      console.info('Cart updated.');
      return;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default SideCart;